import angular from 'angular';
import wageAdvanceListComponent from './wageAdvanceList.component';
import wageAdvanceCard from './wageAdvanceCard/wageAdvanceCard';

let wageAdvanceListModule = angular.module('wageAdvanceList', [
  wageAdvanceCard
])

.component('wageAdvanceList', wageAdvanceListComponent)

.name;

export default wageAdvanceListModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/wageAdvance/wageAdvanceList/wageAdvanceList.js